import { render, staticRenderFns } from "./SendReportModal.vue?vue&type=template&id=3f746827"
import script from "./SendReportModal.vue?vue&type=script&lang=ts"
export * from "./SendReportModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports